import { createContext, useState } from 'react';

import OrgUnitAthleteContactData from './OrgUnitAthleteContactData';

export const OrgUnitAthleteContactStateContext = createContext();

const OrgUnitAthleteContactContextProvider = ({ children }) => {
  const stateHook = useState(OrgUnitAthleteContactData.INITIAL_STATE);

  return (
    <OrgUnitAthleteContactStateContext.Provider value={stateHook}>
      {children}
    </OrgUnitAthleteContactStateContext.Provider>
  );
};

export default OrgUnitAthleteContactContextProvider;